// styles
import styled from "styled-components";
import { STATUS_THEME, ERP_TO_DESIGN_KEY } from "../../../constants/statusTheme";

export const StatusPillStyles = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  min-width: 80px;
  padding: 2px 10px;
  border-radius: ${({ theme }) => theme.radius.rounded};
  font-style: normal;
  font-weight: 600;
  font-size: ${({ theme }) => theme.typography.body.b3.size};
  line-height: ${({ theme }) => theme.typography.body.b3.lineHeight};
  text-align: center;
  text-transform: capitalize;
  ${({ $status }) => {
    const designKey = ERP_TO_DESIGN_KEY[$status];
    const palette = STATUS_THEME[designKey] ?? STATUS_THEME.pending;
    return `
      background: ${palette.bg};
      color: ${palette.fg};
      border: 1px solid ${palette.chip}55;
    `;
  }};
`;
